import { render, staticRenderFns } from "./UserDetailDialog.vue?vue&type=template&id=b5108178&scoped=true"
import script from "./UserDetailDialog.vue?vue&type=script&lang=js"
export * from "./UserDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./UserDetailDialog.vue?vue&type=style&index=0&id=b5108178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5108178",
  null
  
)

export default component.exports